export const PLANE_WIDTH = 80
export const PLANE_HEIGHT = 70
export const PLANE_SEGMENT_WIDTH = PLANE_WIDTH * 3
export const PLANE_SEGMENT_HEIGHT = PLANE_HEIGHT * 2
export const PLANE_ROTATION = -Math.PI / 4

export const PLANE_POSITION_Y = 0
export const PLANE_POSITION_Z = -20



// WEBPACK FOOTER //
// ./three/constants/intro.js